export default {
  name: "close",
  class: `h-6 w-5 text-gray-400`,
  box: 24,
  svg: `<path stroke-linecap="round" stroke="fillcolor" stroke-linejoin="round" d="M4.5 19.5l15-15m-15 0l15 15"/>`,
};
